<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("tlt.material.list") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <!-- <li class="breadcrumb-item">
            <router-link to="/master">
              <span>{{$t('tlt.master')}}</span>
            </router-link>
          </li>-->
          <li class="breadcrumb-item">
            <router-link to="/master/material">
              <span>{{$t('tlt.material.list')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button class="btn btn-outline-primary" v-on:click="MMFNew('material')">
            <i class="fa fa-fw fa-lg fa-plus"></i>
            <span class="text">{{ $t("btn.basic.add") }}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{ $t("tlt.material.matCode") }}:</label>
                  <!-- <dimsearch
                    v-model="matCodeFilter"
                    :entity="materials"
                    bindId="materialFilter"
                    bindProp="matCode"
                    submitProp="matCode"
                  ></dimsearch> -->
                  <input class="form-control" type="text" v-model="matCodeFilter" />
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{ $t("tlt.material.matName") }}:</label>
                  <!-- <dimsearch :entity="materials" bindId="materialFilter" bindProp="matName"></dimsearch> -->
                  <input class="form-control" type="text" v-model="matNameFilter" />
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{ $t("tlt.material.type") }}:</label>
                  <select class="form-control" v-model="matTypeFilter">
                    <option value>{{ $t("lbl.basic.select.one") }}</option>
                    <option value="B">{{ $t("lbl.basic.rawMaterial") }}</option>
                    <option value="E">{{ $t("lbl.basic.Auxiliary") }}</option>
                  </select>
                </div>
                <div class="col-lg-6 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="MMFClearFilter('location')"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                    <button
                      class="btn btn-primary"
                      type="button"
                      v-on:click="MMFLoadRows('material')"
                    >
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{ $t("btn.basic.search") }}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div id="materialResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <mmf-table entity="material" inline-actions-disabled singleChoice></mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { gridFields, filterFields } from "@/model/master/Material";
import MmfTable from "@/components/MmfTable";
import dimsearch from "@/components/MMFDimSearch";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "material/getField",
  mutationType: "material/updateField"
});

export default {
  name: "materialList",
  data() {
    return {
      checkedItems: [],
      materials: []
    };
  },
  components: { MmfTable, dimsearch },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.material.rows,
      tableColumns: gridFields
      //            childs: state => state.material.childs
    })
  },
  methods: {
    //    ...mapActions("material", ["loadChildOf"]),
    ...mapActions("base", [
      "MMFselectRow",
      "MMFselectAllRows",
      "MMFNew",
      "MMFEdit",
      "MMFLoadRows",
      "MMFDelete",
      "MMFClearFilter"
    ]),
    clearFilter() {
      this.$store.dispatch("dimSearch/initBind", {
        materialFilter: {
          matCode: "",
          matName: "全部"
        }
      }),
        this.MMFClearFilter("material");
    },
    actionDisabled() {
      return this.checkedItems.length != 1;
    }
  },
  created() {
    this.$store
      .dispatch(
        "api/get",
        {
          url: this.$store.state.material.baseModuleUrl + "/material/findAll"
        },
        {
          root: true
        }
      )
      .then(data => {
        this.materials = data;
      }),
      this.$store
        .dispatch(
          "api/get",
          {
            url: this.$store.state.material.baseModuleUrl + "/material/findAll"
          },
          {
            root: true
          }
        )
        .then(data => {
          this.materials = data;
        });
  }
};
</script>

